// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__TqHFP","containerItemsCenter":"Skeleton_containerItemsCenter__2qFYY"};